import { Box, Typography } from '@mui/material';
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import InstitutionsImage from '../icons/InstitutionsImage';

const RankingComponent = ({ data = [], isInstitute = false }) => {
  const isValidData = (index) => {
    return (
      data &&
      data[index] &&
      data[index].foto !== undefined &&
      data[index].rank !== undefined &&
      data[index].turma !== undefined &&
      data[index].aluno !== undefined
    );
  };

  const hasFirstPlace = isValidData(0);
  const hasSecondPlace = isValidData(1);
  const hasThirdPlace = isValidData(2);

  return (
    <Box
      mt={15}
      sx={{ display: 'flex', height: '400px', boxSizing: 'border-box', marginTop: '80px', justifyContent: 'center' }}
    >
      {/* Second Place */}
      {hasSecondPlace && <Box display={'flex'} flexDirection={'column'} alignItems={'center'} height={'400px'} justifyContent={'end'}>
        <Box display={'flex'} flexDirection={'column'} alignItems={'center'} mb={2}>
          <Box
            sx={{
              background: '#E04A4C',
              padding: '1px',
              position: 'absolute',
              zIndex: '1',
              color: '#fff',
              fontWeight: 700,
              borderRadius: '50%',
              width: '20px',
              display: 'flex',
              justifyContent: 'center',
              marginTop: '65px',
              marginLeft: '67px',
              fontSize: '12px',
            }}
          >
            2
          </Box>
          {isInstitute ? (
            <Box sx={{ border: '1px solid #6F509680', borderRadius: '50%', padding: '15px 13px' }}>
              <InstitutionsImage sx={{ fontSize: '60px', marginTop: '-13px' }} />
            </Box>
          ) : (
            <Box>
              <div
                style={{
                  width: '86px',
                  height: '86px',
                  borderRadius: '50%',
                  background: '#fdc500',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  color: '#000',
                }}
              >
                {data[1].foto}
              </div>
            </Box>
          )}
          <Typography mt={2} fontSize={14} fontWeight={'bold'}>
            {data[1].rank}
          </Typography>
          <Typography fontSize={14} fontWeight={'bold'}>
            {data[1].turma}
          </Typography>
        </Box>
        <Box
          display={'flex'}
          flexDirection={'column'}
          alignItems={'center'}
          mt={0}
          sx={{
            minWidth: '149px',
            minHeight: '250px',
            backgroundColor: '#6F509680',
            borderRadius: '10px 0px 0px 10px',
            borderBottom: 0,
            justifyContent: 'space-between',
            paddingBottom: '30px',
          }}
        >
          <Typography mt={2} color={'#FFF'} fontSize={14} fontWeight={'bold'} textAlign={'center'} maxWidth={'120px'}>
            {data[1].aluno}
          </Typography>
          <WorkspacePremiumIcon sx={{ marginTop: '20px', color: '#FFF', width: 80, height: 80 }} />
        </Box>
      </Box>}

      {/* First Place */}
      {hasFirstPlace &&
        <Box display={'flex'} flexDirection={'column'} alignItems={'center'} height={'400px'} justifyContent={'end'}>
          <Box display={'flex'} flexDirection={'column'} alignItems={'center'} mb={2}>
            <Box
              sx={{
                background: '#E04A4C',
                padding: '1px',
                position: 'absolute',
                zIndex: '1',
                color: '#fff',
                fontWeight: 700,
                borderRadius: '50%',
                width: '20px',
                display: 'flex',
                justifyContent: 'center',
                marginTop: '65px',
                marginLeft: '67px',
                fontSize: '12px',
              }}
            >
              1
            </Box>
            {isInstitute ? (
              <Box sx={{ border: '1px solid #F6BE33', borderRadius: '50%', padding: '15px 13px' }}>
                <InstitutionsImage sx={{ fontSize: '60px', marginTop: '-13px' }} />
              </Box>
            ) : (
              <Box>
                <div
                  style={{
                    width: '86px',
                    height: '86px',
                    borderRadius: '50%',
                    background: '#fdc500',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    color: '#000',
                  }}
                >
                  {data[0].foto}
                </div>
              </Box>
            )}
            <Typography mt={2} fontSize={14} fontWeight={'bold'}>
              {data[0].rank}
            </Typography>
            <Typography fontSize={14} fontWeight={'bold'}>
              {data[0].turma}
            </Typography>
          </Box>
          <Box
            display={'flex'}
            flexDirection={'column'}
            alignItems={'center'}
            mt={0}
            sx={{
              minWidth: '149px',
              minHeight: '300px',
              backgroundColor: '#FDC500',
              borderRadius: '10px 10px 0px 0px',
              justifyContent: 'space-between',
              paddingBottom: '50px',
            }}
          >
            <Typography mt={2} color={'#FFF'} fontSize={14} fontWeight={'bold'} textAlign={'center'} maxWidth={'120px'}>
              {data[0].aluno}
            </Typography>
            <EmojiEventsIcon sx={{ marginTop: '20px', color: '#FFF', width: 80, height: 80 }} />
          </Box>
        </Box>}

      {/* Third Place */}
      {hasThirdPlace && <Box display={'flex'} flexDirection={'column'} alignItems={'center'} height={'400px'} justifyContent={'end'}>
        <Box display={'flex'} flexDirection={'column'} alignItems={'center'} mb={2}>
          <Box
            sx={{
              background: '#E04A4C',
              padding: '1px',
              position: 'absolute',
              zIndex: '1',
              color: '#fff',
              fontWeight: 700,
              borderRadius: '50%',
              width: '20px',
              display: 'flex',
              justifyContent: 'center',
              marginTop: '65px',
              marginLeft: '67px',
              fontSize: '12px',
            }}
          >
            3
          </Box>
          {isInstitute ? (
            <Box sx={{ border: '1px solid #6F509680', borderRadius: '50%', padding: '15px 13px' }}>
              <InstitutionsImage sx={{ fontSize: '60px', marginTop: '-13px' }} />
            </Box>
          ) : (
            <Box>
              <div
                style={{
                  width: '86px',
                  height: '86px',
                  borderRadius: '50%',
                  background: '#fdc500',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  color: '#000',
                }}
              >
                {data[2].foto}
              </div>
            </Box>
          )}
          <Typography mt={2} fontSize={14} fontWeight={'bold'}>
            {data[2].rank}
          </Typography>
          <Typography fontSize={14} fontWeight={'bold'}>
            {data[2].turma}
          </Typography>
        </Box>
        <Box
          display={'flex'}
          flexDirection={'column'}
          alignItems={'center'}
          mt={0}
          sx={{
            minWidth: '149px',
            minHeight: '200px',
            backgroundColor: '#6F509680',
            borderRadius: '0px 10px 10px 0px',
            justifyContent: 'space-between',
            paddingBottom: '30px',
          }}
        >
          <Typography mt={2} color={'#FFF'} fontSize={14} fontWeight={'bold'} textAlign={'center'} maxWidth={'120px'}>
            {data[2].aluno}
          </Typography>
          <WorkspacePremiumIcon sx={{ marginTop: '20px', color: '#FFF', width: 80, height: 80 }} />
        </Box>
      </Box>}
    </Box>
  );
};

export default RankingComponent;